import { Component, OnInit } from '@angular/core';
import { AllPageService } from "src/app/shared/services/all-page.service";

@Component({
  selector: 'app-officialpartners',
  templateUrl: './officialpartners.component.html',
  styleUrls: ['./officialpartners.component.scss']
})
export class OfficialpartnersComponent implements OnInit {

  sponsorsList: any = "";
  bannerrequest: any = {};
  bannerList: any = "";

  constructor(private allpagesService: AllPageService,) { }

  ngOnInit() {
    this.loadBanner();
    this.allpagesService.getSponsors().then((data) => {
      this.sponsorsList = data;
      console.log(this.sponsorsList);
    });
  }

  loadBanner() {
    this.bannerrequest = {
      title: "Official Partners"
    };
    let request = Object.assign({}, this.bannerrequest);
    this.allpagesService.getBannerList(request).then((data: any) => {
      this.bannerList = data.data[0];
      console.log(this.bannerList);
    });
  }

}
